import defaultTheme from './default';
import css from '../../../utils/css';

export default defaultTheme +
  css`
    :host {
      --widget-font-family: 'Ariana Pro', sans-serif;

      --jockeyclub-black: #000;
      --jockeyclub-blue: #26334e;
      --jockeyclub-pearl: #ede2c9;
      --jockeyclub-pastel-red: #ff6d64;
      --jockeyclub-white: #fff;

      --widget-text-color: var(--jockeyclub-blue);

      --widget-header-bg-color: var(--jockeyclub-blue);
      --widget-header-text-color: var(--jockeyclub-pearl);
      --widget-header-odds-shadow: #ccc;

      --widget-grid-compare-active-bg-color: var(--jockeyclub-pastel-red);
      --widget-grid-compare-color: var(--jockeyclub-blue);

      --widget-mobile-seeall-color: var(--jockeyclub-black);

      --widget-grid-best-odds-text-color: var(--jockeyclub-white);
    }
  `;
